export const SET_APPLICATION_LIST = 'SET_APPLICATION_LIST';
export const SET_CURRENT_APPLICATION = 'SET_CURRENT_APPLICATION';
export const SET_APPLICATION_STEP = "SET_APPLICATION_STEP";
export const DELETE_APPLICATION_CARD = "DELETE_APPLICATION_CARD"
export const ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
export const SET_IS_ADMIN_VARIABLE = "SET_IS_ADMIN_VARIABLE";
export const ACCEPT_APPLICATION = "ACCEPT_APPLICATION";
export const DECLINE_APPLICATION = "DECLINE_APPLICATION";
export const SET_APPLICATIONS_EXIST = "SET_APPLICATIONS_EXIST";
export const LOAD_MORE_APPLICATIONS = "LOAD_MORE_APPLICATIONS";
export const SET_APPLICATION_ANSWERS = "SET_APPLICATION_ANSWERS";
export const SET_TOTAL_OPEN = "SET_TOTAL_OPEN";
export const SET_TOTAL_CLOSED = "SET_TOTAL_CLOSED";
export const SET_TOTAL_QUEUE = "SET_TOTAL_QUEUE";
export const ADD_FEEDBACK = 'ADD_FEEDBACK'


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/applicationTrackingSystem/mutation-types.ts